import Controller from '../abstracts/Controller';
import 'scss-templates/t-sizeguide.scss';

export default class SizeGuideController extends Controller {
  static get COMPONENTS() {
    return [
    ];
  }
}
